var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Accordion as BaseAccordion } from '@base-ui-components/react';
import { breakpoints } from "../../tokens/size";
const classes = {
    panel: {
        boxSizing: 'border-box',
        overflow: 'hidden',
        height: 'var(--accordion-panel-height)',
        transition: 'height 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        '&[data-starting-style], &[data-ending-style]': {
            height: 0,
        },
    },
    content: {
        padding: '1.2rem 1.6rem',
        [`@media (max-width: ${breakpoints.sm})`]: {
            padding: '0.8rem 1.6rem',
        },
    },
};
/**
 * Contains the collapsible content for an Accordion.
 *
 * @example
 * <AccordionPanel>Some content</AccordionPanel>
 *
 */
export function AccordionPanel(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (_jsx(BaseAccordion.Panel, Object.assign({ css: classes.panel }, props, { children: _jsx("div", { css: classes.content, children: children }) })));
}
